import { jsx as _jsx } from "react/jsx-runtime";
import { useStore, } from '@mcn-platform/models';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { set } from 'lodash-es';
import React, { useEffect, useRef } from 'react';
import ScormPlaceholder from './ScormPlaceholder';
const ScormWrapper = ({ itemType, item, itemProgress, course, }) => {
    const store = useStore();
    const [scormHost, setScormHost] = React.useState();
    const [scormData, setScormData] = React.useState({
        cmi: {
            core: {
                student_id: store.currentCustomer?.id,
                student_name: store.currentCustomer?.name,
            },
            suspend_data: '',
        },
    });
    const iframeRef = useRef(null);
    const { scormCommit, trackCourseItemProgress, currentPortal } = useStore();
    const itemKey = itemType === 'courseSection' ? `${course?.key}!${item.id}` : item.key;
    useEffect(() => {
        const ik = itemType === 'courseSection' ? `${course?.key}!${item.id}` : item.key;
        const handler = async (event) => {
            console.log('(wrapper)<< message', event);
            if (event.origin !== scormHost) {
                // console.log('not our event');
                return;
            }
            const { data } = event;
            if (data.type === 'LMSSetValue') {
                const newData = {
                    ...scormData,
                };
                set(newData, data.element, data.value);
                setScormData(newData);
            }
            else if (data.type === 'LMSCommit') {
                if (itemType === 'courseSection') {
                    if (['completed', 'passed'].includes(scormData?.cmi?.core?.lesson_status)) {
                        await trackCourseItemProgress(course?.key, item.id, scormData);
                    }
                }
                else {
                    await scormCommit(itemType, ik, scormData);
                }
                // process and respond
                iframeRef.current?.contentWindow?.postMessage('commit successful', '*');
            }
            else if (data.type === 'GetConfiguration') {
                // process and respond
                iframeRef.current?.contentWindow?.postMessage({
                    type: 'SetConfiguration',
                    scormData: itemProgress.scormData || {
                        cmi: {
                            core: {
                                student_id: store.currentCustomer?.id,
                                student_name: store.currentCustomer?.name,
                            },
                            suspend_data: '',
                        },
                    },
                }, '*');
            }
            else {
                console.log('no action for this event type');
            }
        };
        window.addEventListener('message', handler);
        // clean up
        return () => window.removeEventListener('message', handler);
    }, [
        itemType,
        item,
        course?.key,
        itemProgress,
        scormCommit,
        scormData,
        scormHost,
        store.currentCustomer?.id,
        store.currentCustomer?.name,
        trackCourseItemProgress,
    ]);
    useEffect(() => {
        // const host = 'http://localhost:8001';
        const domain = currentPortal.publicDomain || currentPortal.cloudfrontDistributionDomain;
        const host = domain ? `https://${domain}` : undefined;
        setScormHost(host);
    }, [
        currentPortal.cloudfrontDistributionDomain,
        currentPortal.publicDomain,
        // repository.syncState,
    ]);
    const organizationID = store.currentOrganization.id;
    console.log('scormHost', scormHost);
    if (!scormHost || !itemProgress) {
        return (_jsx(ScormPlaceholder, {}));
    }
    const src = `${scormHost}/play/scorm/${organizationID}/${currentPortal.id}/${itemType}/${itemKey}/scorm12_template.html`;
    // src={`http://localhost:8001/scorm/${organizationID}/${currentPortalID}/${course.key}/scorm12_template.html`}
    // console.log('iframe src', src);
    return (_jsx(Box, { sx: { width: '100%', height: '100%' }, children: _jsx("iframe", { ref: iframeRef, title: "scorm", src: src, style: {
                width: '100%',
                height: '98%',
                border: 'none',
                minHeight: '500px',
                // overflow: 'hidden',
            }, scrolling: "no" }) }));
};
ScormWrapper.defaultProps = {
    course: undefined,
};
export default observer(ScormWrapper);
//# sourceMappingURL=ScormWrapper.js.map